import {
  INVOICE_BATCH_URGENT_CATEGORY_LIST_REQUEST,
  INVOICE_BATCH_URGENT_CATEGORY_LIST_RECEIVED,
  INVOICE_BATCH_URGENT_CATEGORY_LIST_ERROR,
} from '../constants';

const reducer = (
  state = {
    invoiceBatchUrgentCategories: [],
    isFetchingInvoiceBatchUrgentCategories: false,
  },
  action,
) => {
  switch (action.type) {
    case INVOICE_BATCH_URGENT_CATEGORY_LIST_REQUEST:
      state = {
        ...state,
        isFetchingInvoiceBatchUrgentCategories: true,
      };
      return state;

    case INVOICE_BATCH_URGENT_CATEGORY_LIST_RECEIVED:
      state = {
        ...state,
        invoiceBatchUrgentCategories: action.data['hydra:member'],
        isFetchingInvoiceBatchUrgentCategories: false,
      };
      return state;

    case INVOICE_BATCH_URGENT_CATEGORY_LIST_ERROR:
      state = {
        ...state,
        isFetchingInvoiceBatchUrgentCategories: false,
      };
      //      console.log(state);
      return state;

    default:
      return state;
  }
};

export default reducer;
